"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const intl_1 = require("@kyruus/intl");
const prop_types_1 = require("prop-types");
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../../../lib/messages"));
const button_1 = __importDefault(require("@kyruus/button"));
const Popover = ({ buttonRef, dataTestId, direction, onClose, children, intl }) => {
    const handleClickOutside = ({ target }) => {
        if (buttonRef.current.contains(target) === false)
            onClose();
    };
    const handleCloseKey = ({ key }) => {
        if (key === 'Escape')
            onClose();
    };
    (0, react_1.useEffect)(() => {
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleCloseKey);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleCloseKey);
        };
    });
    return (react_1.default.createElement(styles_1.CustomPaper, { className: direction, elevation: 4, "data-testid": dataTestId },
        children,
        react_1.default.createElement(styles_1.CancelButtonContainer, null,
            react_1.default.createElement(button_1.default, { onClick: onClose, "aria-label": intl.formatMessage(messages_1.default.ariaJumpToDateFilterCloseButton), "data-testid": `${dataTestId}-close` },
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.apptTimeFilterCloseBtn))))));
};
Popover.propTypes = {
    dataTestId: prop_types_1.string,
    direction: (0, prop_types_1.oneOf)(['right', 'left']),
    onClose: prop_types_1.func.isRequired,
    children: prop_types_1.node.isRequired,
    buttonRef: (0, prop_types_1.shape)({ current: react_1.Element }).isRequired,
    intl: (0, prop_types_1.shape)({
        formatMessage: prop_types_1.func.isRequired
    }).isRequired
};
exports.default = (0, intl_1.injectIntl)(Popover);
//# sourceMappingURL=Popover.js.map